import {
  getModule,
  Module,
  VuexModule,
  MutationAction
} from "vuex-module-decorators";
import store from "@/store";
import { SessionStorage } from "@/store/session-storage";
import { SearchItem, SearchResponse } from "@/api/regist-stripe-shop/response";
import { SearchRequest } from "@/api/regist-stripe-shop/request";
import * as RegistStripeShopAPI from "@/api/regist-stripe-shop";
import { isSuccess } from "@/api/response";

const MODULE_NAME = "regist-stripe-shop/search";

export class ListItem {
  constructor(private _item: SearchItem) {}
  get id() {
    return this._item.id;
  }

  get name() {
    return this._item.name;
  }

  get appName() {
    return this._item.appName;
  }

  get stripeRegistStatus() {
    return this._item.stripeRegistStatusName;
  }

  get stripeRegistUrl() {
    return this._item.stripeRegistUrl;
  }

  get stripeDashboardUrl() {
    return this._item.stripeDashboardUrl;
  }

  get writeFlg() {
    return this._item.writeFlg;
  }

  get actionFlg() {
    return 1;
  }
}

/**
 * Stripe加盟店登録情報一覧・検索API（/search-regist-stripe-shop）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Search extends VuexModule {
  // state
  searchRequest: SearchRequest = {} as SearchRequest;
  searchResponse: SearchResponse = {} as SearchResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.searchResponse);
  }

  get getMessage() {
    return this.searchResponse.message;
  }

  get getItems() {
    if (this.searchResponse.results) {
      const items = this.searchResponse.results.items || [];
      return items.map(v => new ListItem(v));
    } else {
      return [];
    }
  }

  get getTotalCount() {
    if (this.searchResponse.results) {
      return this.searchResponse.results.totalCount || 0;
    } else {
      return 0;
    }
  }

  get getSearchRequest() {
    return this.searchRequest;
  }

  // MutationActions
  @MutationAction
  async search(searchRequest: SearchRequest) {
    const searchResponse = await RegistStripeShopAPI.search(searchRequest);
    SessionStorage.setObject(MODULE_NAME, searchRequest);
    return {
      searchRequest,
      searchResponse
    };
  }

  @MutationAction
  async restore(initial = {} as SearchRequest) {
    const searchRequest = SessionStorage.getObject(
      MODULE_NAME,
      initial
    ) as SearchRequest;
    return {
      searchRequest
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      searchResponse: {} as SearchResponse
    };
  }
}

export default getModule(Search);
